import type { PivotData } from './types'
import type { PivotField } from '@ztechapps/common.contract'
import { PivotFieldTypeEnum } from '@ztechapps/common.contract'

const toPivotFieldType = (type: unknown): PivotFieldTypeEnum => {
  if (type === PivotFieldTypeEnum.Number) return PivotFieldTypeEnum.Number
  if (type === PivotFieldTypeEnum.Date) return PivotFieldTypeEnum.Date
  return PivotFieldTypeEnum.String
}

/** Converts a report response into pivot fields and rows. */
export const toPivotData = (response: unknown[]): PivotData => {
  const header = response[0]
  const fields: PivotField[] =
    typeof header === 'object' && header !== null
      ? Object.keys(header).map((name) => ({
          name,
          type: toPivotFieldType((header as Record<string, { type?: unknown }>)[name]?.type),
        }))
      : []
  return { fields, rows: response.slice(1) as unknown[][] }
}
